// src/components/Tag.jsx
import React from "react";
import { Badge } from "components/ui/badge";
import { getColorStyle } from "utils/tagColor";

const Tag = ({ name, color, className = "", style, ...props }) => {
  const colorStyle = getColorStyle(color);

  return (
    <Badge
      variant="secondary"
      className={`rounded-full px-3 py-1 text-sm ${colorStyle ? "" : "bg-primary/10 text-primary"} border-transparent ${className}`}
      style={{ ...colorStyle, ...style }}
      {...props}
    >
      {name}
    </Badge>
  );
};

export default Tag;
